import { BaseModel } from "sjs-base-model";
import CommissioneBancaSegnalante from "./commisioniBancaSegnalanteModel";
import ProvviggioneAgenteBase from "./richiestaCedibilita/ProvviggioneAgenteBaseModel";

export default class ValoriInterfaccia extends BaseModel {
    public readonly commissioniCessionaria: CommissioneBancaSegnalante = new CommissioneBancaSegnalante({});
    public readonly totaleCommissioniPassive: number = 0;
    public readonly ImpostaSostitutiva: CommissioneBancaSegnalante = new CommissioneBancaSegnalante({});
    public readonly Bollo: number = 0;
    public readonly OneriPerRata: number = 0;
    public readonly extraprovvigione: CommissioneBancaSegnalante = new CommissioneBancaSegnalante({});
    public readonly commissioniBanca: CommissioneBancaSegnalante = new CommissioneBancaSegnalante({});
    public readonly commissioniAgente: CommissioneBancaSegnalante = new CommissioneBancaSegnalante({});
    public readonly ProvvigioniCommissioniTot: CommissioneBancaSegnalante = new CommissioneBancaSegnalante({});
    public readonly CostiMediatori: CommissioneBancaSegnalante = new CommissioneBancaSegnalante({});
    public readonly CommissioneBancaSegnalante: CommissioneBancaSegnalante = new CommissioneBancaSegnalante({});
    public readonly SpeseIstruttoria: CommissioneBancaSegnalante = new CommissioneBancaSegnalante({});
    public readonly PercentualeMaxSuMontante: CommissioneBancaSegnalante = new CommissioneBancaSegnalante({});
    public readonly interessiSuMontante: CommissioneBancaSegnalante = new CommissioneBancaSegnalante({});
    public readonly CommissioniPassiveUpFront: CommissioneBancaSegnalante = new CommissioneBancaSegnalante({});
    public readonly CommissioniPassiveRunning: CommissioneBancaSegnalante = new CommissioneBancaSegnalante({});
    public readonly CommissioniPratica: number = 0;
    public readonly VaCapitale: number = 0;
    public readonly percentualTanBase: number = 0;
    public readonly ValMaxMontante_totale: number = 0;
    public readonly valorePopupDettaglioTan_TanSuProdotto: string | null = null;
    public readonly valorePopupDettaglioTan_TanDerogato: string | null = null;
    public readonly valorePopupDettaglioTan_DerogaDaTipologiaPratica: string | null = null;
    public readonly valorePopupDettaglioTan_DerogaManuale: string | null = null;
    public readonly idTipologiaPraticaRichiesta: string | null = null;
    public readonly provviggioneAgenteBase: ProvviggioneAgenteBase = new ProvviggioneAgenteBase({});

    constructor(data: Partial<ValoriInterfaccia>) {
        super();

        this.update(data);
    }
}
